const courseFee = {
    "promotion": {
        "announcementDate": "2021/05/12",
        "content": "本會訓練業務費用調整與優惠方式：此案於2018年10月1日起實施。\n" +
            "\t1.本會訓練課程暫不調整費用，一天課程費用3,000元、兩天的課程費用5,500元、三天的課程費用7,700元。\n" +
            "\t2.本會符合性評鑑訓練提供以下三項優惠方案，參加學員僅可選擇其一方案優惠，不得併案重覆優惠。\n" +
            "\t\t● 甲案：同一單位於同一班課程報名三人（含）以上給予9折優惠，若於上課時實際上課人數未達三人，將取消本案之優惠。\n" +
            "\t\t● 乙案：同一單位於每季課程中報名人數達10人次(含)以上給予9折優惠，本優惠方案必須單位事先申請並完成報名，提供參訓人員名單，且經本會確認後方可享此優惠。\n" +
            "\t\t● 丙案：與本會簽署合作備忘錄機關(構)之職員或會員，參加本會特定領域(醫學類別課程、量測不確定度研討會(化學專班)及土木類課程)相關訓練課程，且報名時出示職員證或含會員編號之會員證件者，該課程予以8折優惠。(原醫檢學會會員八折優惠不變，符合此丙案)\n" +
            "【註】： 同一單位係以報名資料之統一編號為認定依據。"
    },
    "payment": {
        "announcementDate": "2021/05/19",
        "content": "繳費方式說明：\n" + "\n" +
            "一、虛擬帳號繳費\n" + "\n" +
            "步驟1.--將於課前三週寄送繳款通知書及課前須知至報名時所填寫的Email信箱。\n" + "\n" +
            "步驟2.--待收到繳款單後，請於開課前至超商(或郵局、銀行臨櫃)進行繳款 。\n" + "\n" +
            "步驟3.--完成繳款後，請將繳費收據註明您的姓名、電話及課程代碼並傳真（02-2809-0979 TAF 教育訓練收），以便核對確認您的款項。\n" + "\n" +
            "二、匯款至土銀帳號繳費：\n" + "\n" +
            "以銀行匯款或者金融卡轉帳，付完款後請來電告知或者傳真相關資料，請註明上課學員姓名及公司，以利作業。\n" + "\n" +
            "銀行名稱：土地銀行大安分行\n" +
            "銀行代碼：005-1231\n" +
            "戶名：財團法人全國認證基金會\n" +
            "帳號： 123-001-001609\n" +
            "FAX：02-2809-0979 教育訓練 收\n" +
            "收到款項後，會立即開發票並寄回給您。\n" + "\n" +
            "三、支票付款\n" + "\n" +
            "可於課前郵寄支票，請註明上課學員姓名及公司\n" +
            "支票抬頭：財團法人全國認證基金會\n" +
            "寄至：25170新北市淡水區中正東路二段27號23樓 教育訓練 收"
    }
};

export default courseFee;